<rap-songs-ui [songs]="songs$ | async" (createSongEmitter)="createSong()" (deleteSongEmitter)="deleteSong($event)"
    (searchSongEmitter)="searchSong($event)" [isContributions]="isContributions"></rap-songs-ui>